import { render, staticRenderFns } from "./edit-faq.vue?vue&type=template&id=a882184c&"
import script from "./edit-faq.vue?vue&type=script&lang=js&"
export * from "./edit-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports